import { useMemo } from 'react';
import { DdbEngagementType } from '@/lib/graphql/types-and-hooks';
import { useEngagementsBase } from './use-engagements-base';

// Dummy data for preview mode
const dummyMeetings = [
  {
    id: '1',
    title: 'Deal Review & Next Steps',
    date: 'Feb 27, 2026',
    attendees: ['Sarah Chen', 'Doug'],
    companies: ['TechVentures Inc'],
  },
  {
    id: '2',
    title: 'Pricing Discussion',
    date: 'Feb 18, 2026',
    attendees: ['James Wilson', 'Doug'],
    companies: ['TechVentures Inc'],
  },
];

const dummyEmails = [
  {
    id: '1',
    title: 'Re: Updated Proposal',
    from: 'Sarah Chen',
    date: 'Feb 28, 2026',
    preview: 'Thanks for the updated proposal...',
  },
  {
    id: '2',
    title: 'Updated Proposal — Q2',
    from: 'Doug',
    date: 'Feb 25, 2026',
    preview: 'Attached is the updated proposal...',
  },
];

interface UseDealEngagementsOptions {
  dealId: string;
  type?: DdbEngagementType;
  pageSize?: number;
  skip?: boolean;
}

/**
 * Hook for fetching engagements (meetings/emails) associated with a deal
 * Supports pagination and Lovable Preview mode
 */
export const useDealEngagements = ({
  dealId,
  type,
  pageSize = 20,
  skip = false,
}: UseDealEngagementsOptions) => {
  const entityFilter = useMemo(() => ({ dealId }), [dealId]);

  return useEngagementsBase({
    entityFilter,
    entityId: dealId,
    type,
    pageSize,
    skip,
    dummyMeetings,
    dummyEmails,
  });
};
